import React from 'react'

export default function LandingPage() {
    return (
        <div className="tab-inner-section">
            <div className="trans-header">
                <div className="d-flex lead-gen-wrapper">
                    <div className="lead-gen-left">
                        <div className="tab-inner-wrapper">
                            <div className="tab-inner-heading d-flex justify-content-between align-items-center">
                                <div className="left-wrap">
                                    <div className="ques-options">
                                        <h5>Particulars</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex-grow-1 lead-gen-main">
                        <div className="row gx-0">
                            <div className="col-lg-6">
                                <div className="tab-inner-wrapper">
                                    <div className="tab-inner-heading">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="left-wrap d-flex">
                                                <div className="drop-wrap ques-options">
                                                    <h5>ENG</h5>
                                                    <p>Default</p>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="tab-inner-wrapper right-tab">
                                    <div className="tab-inner-heading">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="left-wrap d-flex">
                                                <div className="drop-wrap">
                                                    <div className="dropdown table-dropdown ques-options">
                                                        <button className="btn dropdown-tgl" type="button" id="languages" data-bs-toggle="dropdown"
                                                            aria-haspopup="true" aria-expanded="false">
                                                            <span className='me-2'>SPA</span>
                                                        </button>
                                                        <div className="dropdown-menu" aria-labelledby="languages">
                                                            <a className="dropdown-item" href="#">
                                                                English
                                                            </a>
                                                            <a className="dropdown-item" href="#">
                                                                German
                                                            </a>
                                                            <a className="dropdown-item" href="#">
                                                                Spanish
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <p>Spanish</p>
                                                </div>
                                            </div>
                                            <div className="right-action-btn">
                                                <button type="button" className="btn btn-bordered">Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="trans-wrap">
                <div className="d-flex lead-gen-wrapper">
                    <div className="lead-gen-left">
                        <div className="tab-inner-wrapper">
                            <div className="questions-wrapper">
                                <div className="translation-list">
                                    <div className="translate"><p>Hero heading</p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex-grow-1 lead-gen-main">
                        <div className="row gx-0">
                            <div className="col-lg-6">
                                <div className="tab-inner-wrapper">
                                    <div className="questions-wrapper">
                                        <div className="translation-list">
                                            <div className="translate d-flex align-items-center">
                                                <div className="Sortingcheck">
                                                    <input type="checkbox" className="form-check-input" id="language-check1" />
                                                </div>
                                                <div className='chiceFields choiceInput flex-grow-1'>
                                                    <div className="translate"><p>Check Digital Maturity across 8 dimensions through our assessment.</p></div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="tab-inner-wrapper right-tab">
                                    <div className="questions-wrapper">
                                        <div className="translation-list">
                                            <div className="translate">

                                                <textarea className="choiceItext" cols={1} defaultValue={"Verifique la Madurez Digital en 8 dimensiones a través de nuestra evaluación."} />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex lead-gen-wrapper">
                    <div className="lead-gen-left">
                        <div className="tab-inner-wrapper">
                            <div className="questions-wrapper">
                                <div className="translation-list">
                                    <div className="translate"><p>Hero subtext</p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex-grow-1 lead-gen-main">
                        <div className="row gx-0">
                            <div className="col-lg-6">
                                <div className="tab-inner-wrapper">
                                    <div className="questions-wrapper">
                                        <div className="translation-list">
                                            <div className="translate d-flex align-items-center checked">
                                                <div className="Sortingcheck">
                                                    <input type="checkbox" className="form-check-input" id="language-check1" defaultChecked />
                                                </div>
                                                <div className='chiceFields choiceInput flex-grow-1'>
                                                    <div className="translate"><p>A majority of organisations are still struggling to answer this question. A closer look at your IT infrastructure, cloud strategy, and application lifecycle, among other factors, will indicate where you lie on the cloud maturity spectrum. Take this survey to find out how cloud-ready you are.</p></div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="tab-inner-wrapper right-tab">
                                    <div className="questions-wrapper">
                                        <div className="translation-list">
                                            <div className="translate">

                                                <textarea className="choiceItext" cols={1} defaultValue={"La mayoría de las organizaciones aún luchan por responder a esta pregunta. Una mirada más cercana a su infraestructura de TI, estrategia de nube y ciclo de vida de la aplicación, entre otros factores, indicará dónde se encuentra en el espectro de madurez de la nube. Realice esta encuesta para averiguar qué tan preparado está para la nube."} />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex lead-gen-wrapper">
                    <div className="lead-gen-left">
                        <div className="tab-inner-wrapper">
                            <div className="questions-wrapper">
                                <div className="translation-list">
                                    <div className="translate"><p>Section 2 - Heading</p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex-grow-1 lead-gen-main">
                        <div className="row gx-0">
                            <div className="col-lg-6">
                                <div className="tab-inner-wrapper">
                                    <div className="questions-wrapper">
                                        <div className="translation-list">
                                            <div className="translate d-flex align-items-center">
                                                <div className="Sortingcheck">
                                                    <input type="checkbox" className="form-check-input" id="language-check1" />
                                                </div>
                                                <div className='chiceFields choiceInput flex-grow-1'>
                                                    <div className="translate"><p>What our Digital Maturity Survey covers</p></div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="tab-inner-wrapper right-tab">
                                    <div className="questions-wrapper">
                                        <div className="translation-list">
                                            <div className="translate">
                                                <textarea className="choiceItext" cols={1} defaultValue={"Lo que cubre nuestra Encuesta de Madurez Digital"} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="d-flex lead-gen-wrapper">
                    <div className="lead-gen-left">
                        <div className="tab-inner-wrapper">
                            <div className="questions-wrapper">
                                <div className="translation-list">
                                    <div className="translate"><p>Section 2 - Sub text</p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex-grow-1 lead-gen-main">
                        <div className="row gx-0">
                            <div className="col-lg-6">
                                <div className="tab-inner-wrapper">
                                    <div className="questions-wrapper">
                                        <div className="translation-list">
                                            <div className="translate d-flex align-items-center">
                                                <div className="Sortingcheck">
                                                    <input type="checkbox" className="form-check-input" id="language-check1" />
                                                </div>
                                                <div className='chiceFields choiceInput flex-grow-1'>
                                                    <div className="translate"><p>An assessment of your current cloud maturity level based on 6 key pillars of cloud-readiness: Cloud strategy, hybrid cloud, governance, application lifecycle, infrastructure readiness, and IT service management.</p></div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="tab-inner-wrapper right-tab">
                                    <div className="questions-wrapper">
                                        <div className="translation-list">
                                            <div className="translate">
                                                <textarea className="choiceItext" cols={1} defaultValue={"Una evaluación de su nivel actual de madurez de la nube basada en 6 pilares clave de preparación para la nube: estrategia de nube, nube híbrida, gobierno, ciclo de vida de la aplicación, preparación de la infraestructura y administración de servicios de TI."} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    )
}
